import { ErrorCode } from 'react-dropzone';

export type FolderHistorical = {
  id: string;
  name?: string;
};

export type FolderHistory = FolderHistorical[];

export type FileMap = Record<string, FileWithStatus>;

export enum FileUploadStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  UPLOADING = 'UPLOADING',
  COMPLETED = 'COMPLETED',
  DROPZONE_ERROR = 'DROPZONE_ERROR',
  FILENAME_MISMATCH = 'FILENAME_MISMATCH',
}

export enum PathSelectionMode {
  SELECT = 'select',
  CUSTOM = 'custom',
  FOLDER = 'folder',
}

export interface FileWithStatus {
  id: string;
  name: string;
  size: number;
  path: string;
  file: File;
  status: { state: FileUploadStatus; code?: string | ErrorCode; message?: string; traceId?: string };
  folderId?: string;
  assetId?: string;
}
